import React from 'react';
import { Box, Image } from '@wegroup/design-system';
import WeGroupLogoWhite from '../../../../../../../common/src/assets/WeGroupLogoWhite';
import useAuth from '../../../../../../../app/src/features/authentication/hooks/useAuth';

interface Props {
  url?: string;
}

const ToolbarLogo: React.FC<React.PropsWithChildren<Props>> = ({ url }) => {
  const { distribution } = useAuth();

  if (distribution.id === '36d87970-b81d-4425-bb7f-f23270f13637' || !url) {
    return <WeGroupLogoWhite />;
  }

  return (
    <Box
      display={{ base: 'none', tabletS: 'flex' }}
      mr="4"
      minW="24"
      maxW="72"
      minH="12"
      maxH="24"
      w="100%"
      h="100%"
    >
      <Image
        objectFit="contain"
        w="100%"
        h="100%"
        src={url}
        alt="distribution logo"
      />
    </Box>
  );
};

export default ToolbarLogo;
